@if (state()) {
  <orbit-fa-icon
    class="state-icon"
    [iconName]="getStateIcon()"
    data-testid="message-state-indicator"
    [attr.data-state]="state()" />
}
